define(['morningstar', 'underscore', './date-helper'], function(morningstar, _, dateHelper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromMarketsPriceAndDistributions', function(data) {
        var context = this.context,
            chartSettings = context.instance.model.chartSettings;
        if (!data || !data.Data || !chartSettings) {
            return;
        }

        var primaryData = _.findWhere(data.Data, {Ticker: chartSettings.primaryFund.secId});
        return getPriceAndDistributions(primaryData, context, chartSettings);
    });

    function getPriceAndDistributions(data, context, chartSettings) {
        var formatter = context.instance.getFormatter(),
            exportSettings = context.instance.getSettings().exportSettings,
            newData = {name: chartSettings.primaryFund.name, rows: []},
            priceList = morningstar.asterix.util.parse('DailyData[3244]')(data).reverse(),
            distributionList = morningstar.asterix.util.parse('DailyData.TotalDist')(data);
        _.each(priceList, function(item) {
            var distributionData = _.findWhere(distributionList, {Date: item.Date}),
                distribution = distributionData ? distributionData.Last : 0;
            newData.rows.push({
                date: formatter.date(dateHelper.toDateObject(item.Date), exportSettings.dateFormatAlias),
                price: formatter.number(item.Last, exportSettings.priceFormatAlias),
                distribution: formatter.number(distribution, exportSettings.distributionFormatAlias)
            });
        });
        return newData;
    }
});



// WEBPACK FOOTER //
// ./components/multiple-chart/src/js/transforms/from-markets-price-and-distributions.js